import { render, staticRenderFns } from "./PageSidebar.vue?vue&type=template&id=68242a0e"
import script from "./PageSidebar.vue?vue&type=script&lang=js"
export * from "./PageSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports